import { Erc721Metadata } from '@gu-corp/react-ipfs-media';
import { axiosInstance } from './config';
export const NFTService = {
  getMetadata: async (tokenUri: string) => {
    return axiosInstance.post<Erc721Metadata>('/nft/metadata', { tokenUri });
  },
};
